import React, { useState } from 'react';
import SEOHelmet from '../components/SEOHelmet';

const sponsors = [
  { id: 1, name: 'Sponsor 1', tier: 'gold', description: 'Coming Soon' },
  { id: 2, name: 'Sponsor 2', tier: 'gold', description: 'Coming Soon' },
  { id: 3, name: 'Sponsor 3', tier: 'silver', description: 'Coming Soon' },
  { id: 4, name: 'Sponsor 4', tier: 'silver', description: 'Coming Soon' },
  { id: 5, name: 'Sponsor 5', tier: 'bronze', description: 'Coming Soon' },
  { id: 6, name: 'Sponsor 6', tier: 'bronze', description: 'Coming Soon' },
];

function Sponsors() {
  const [hoveredId, setHoveredId] = useState(null);

  const tiers = [
    { key: 'gold', label: 'Golden Spatula Partners', emoji: '' },
    { key: 'silver', label: 'Krabby Patty Partners', emoji: '' },
    { key: 'bronze', label: 'Jellyfish Net Partners', emoji: '' },
  ];

  return (
    <div>
      <SEOHelmet 
        title="Sponsors - Code It Up 6.0 Hackathon"
        description="Meet the generous sponsors and partners supporting Code It Up 6.0 hackathon. These companies are making our event possible."
        keywords="sponsors, code it up sponsors, hackathon partners, tech sponsors"
        canonical="https://code-it-up-6.netlify.app/sponsors"
      />
      <h1 style={{ textAlign: 'center' }}>OUR SPONSORS</h1>
      <p className="section-subtitle">
        The generous folks fueling our underwater adventure!
      </p>

      {tiers.map((tier) => {
        const tierSponsors = sponsors.filter(s => s.tier === tier.key);
        if (tierSponsors.length === 0) return null;
        return (
          <div key={tier.key} className="sponsor-tier">
            <h2 className={`sponsor-tier-title tier-${tier.key}`}>
              {tier.emoji} {tier.label} {tier.emoji}
            </h2>
            <div className="sponsors-grid">
              {tierSponsors.map((sponsor) => (
                <div
                  key={sponsor.id}
                  className={`sponsor-card tier-${sponsor.tier} ${hoveredId === sponsor.id ? 'sponsor-active' : ''}`}
                  onMouseEnter={() => setHoveredId(sponsor.id)}
                  onMouseLeave={() => setHoveredId(null)}
                >
                  <div className="sponsor-treasure-chest">
                    <div className="treasure-lid"></div>
                    <div className="treasure-body">
                      <div className="sponsor-logo-placeholder">
                        <span>?</span>
                      </div>
                    </div>
                  </div>
                  <h3>{sponsor.name}</h3>
                  <p>{sponsor.description}</p>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Sponsors;
